// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__nlASx","backgroundAnimations":"App_backgroundAnimations__fIi5B"};